<template>
  <v-app>
    <Sidebar ref="sidebarRef" />

    <v-app-bar app>
      <v-btn icon @click="toggleSidebar">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-toolbar-title></v-toolbar-title>
      <v-menu open-on-click offset-y>
        <!--<template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" class="mr-2">
            <v-badge v-if="notificacao" :content="notificacao" color="red" overlap>
              <v-icon color="blue">mdi-bell</v-icon>
            </v-badge>
            <v-icon v-else color="blue">mdi-bell</v-icon>
          </v-btn>
        </template>-->
        <v-card min-width="300" v-if="alertas.length">
          <v-list dense>
            <v-list-item v-for="(alerta, index) in alertas" :key="index" @click="handleAlertaClick(alerta)"
              :class="{ 'clickable-alerta': alerta.action }">
              <v-list-item-content class="d-flex align-center">
                <v-icon :color="alerta.cor" class="mr-2">{{
                  alerta.icone
                }}</v-icon>
                <span>{{ alerta.texto }}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-menu open-on-click offset-y>
        <template v-slot:activator="{ props }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-bind="props" v-on="on" class="me-6">
                <v-avatar color="success">
                  <span class="white--text text-h6">{{ userInitial }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <span>{{ userName }} ({{ userEmail }})</span>
          </v-tooltip>
        </template>

        <v-card width="250">
          <v-card-text class="text-center">
            <p>
              Olá, <strong>{{ userName }}</strong>
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-list>
            <!--<v-list-item @click="goToProfile">
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item>-->
            <v-list-item @click="logout">
              <v-list-item-content class="d-flex align-center">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="ml-2">Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

export default {
  components: {
    Sidebar,
  },
  setup() {
    const router = useRouter();
    const userName = ref("Usuário");
    const userEmail = ref("");
    const userInitial = ref("U");

    const alertas = ref([]);
    const notificacao = ref(null);

    const adicionarAlerta = ({ texto, icone = null, cor = null, action = null }) => {
      alertas.value.push({ texto, icone, cor, action });
      notificacao.value = alertas.value.length;
    };


    const goToProfile = () => {
      const usuario = JSON.parse(localStorage.getItem("setUser"));
      router.push({
        name: "cadastroUsuario",
        params: { id: usuario.id },
        state: { usuarioSelecionado: usuario },
      });
    };

    const handleAlertaClick = (alerta) => {
      if (alerta.action === 'goToInvoice') {
        goToInvoice();
      }
    };

    const logout = () => {
      localStorage.removeItem("setUser");
      localStorage.removeItem("setToken");
      router.push("/app/manager");
    };

    onMounted(() => {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const parsedData = JSON.parse(userData);
        const usuario = parsedData.user;

        if (usuario) {
          userName.value = usuario.name || usuario.email;
          userEmail.value = usuario.email || "";
          userInitial.value = userName.value.charAt(0).toUpperCase();
        }
      }

    });

    return {
      logout,
      userName,
      userEmail,
      userInitial,
      goToProfile,
      alertas,
      notificacao,
      handleAlertaClick,
    };
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebarRef.toggleDrawer();
    },
  },
};
</script>

<style scoped>
.v-avatar {
  width: 40px;
  height: 40px;
}

.clickable-alerta {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.clickable-alerta:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>